import { useEffect, useRef } from 'react';

/**
 * Aggiornamento "quasi in tempo reale": richiama `refresh` ogni `ms` millisecondi
 * SOLO mentre la scheda del browser è visibile, e subito quando l'utente ci torna.
 * Così la bacheca e il PED mostrano le modifiche dei colleghi senza ricaricare
 * la pagina, senza sprecare richieste quando la scheda è in background.
 */
export function useLiveRefresh(refresh, ms = 30000, enabled = true) {
  const fn = useRef(refresh);
  useEffect(() => { fn.current = refresh; }, [refresh]);

  useEffect(() => {
    if (!enabled) return undefined;
    let timer = null;
    const tick = () => { if (document.visibilityState === 'visible') fn.current(); };
    const start = () => { stop(); timer = setInterval(tick, ms); };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const onVis = () => { if (document.visibilityState === 'visible') { fn.current(); start(); } else stop(); };
    start();
    document.addEventListener('visibilitychange', onVis);
    return () => { stop(); document.removeEventListener('visibilitychange', onVis); };
  }, [ms, enabled]);
}
